export default {
  condition: {
    id: 'grade_description_condition_label',
    defaultMessage: 'Condition:',
  },
}
